<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-card min-height="600">
          <div class="card">
            <v-row justify="center">
              <iframe id="ytplayer" type="text/html" width="839" height="472" :src="embedUrl" frameborder="0" />
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ElementExecutionBack />
  </v-container>
</template>

<script>
import ElementExecutionBack from '@/components/course/navigation/ElementExecutionBack.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    ElementExecutionBack
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    courseId: {
      type: Number,
      required: true
    }
  },
  computed: {
    execution() {
      return JSON.parse(this.element.execution);
    },
    youtubeUrl() {
      return this.execution.url;
    },
    urlEnd() {
      if (!this.youtubeUrl.startsWith('https://youtu.be')) {
        const queryParams = new URLSearchParams(this.youtubeUrl.split('?')[1]);
        return `${queryParams.get('v')}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      } else {
        let urlEnd = this.youtubeUrl.split('.be/')[1];
        const splittedPath = urlEnd.split('?');
        urlEnd = splittedPath[0];
        const queryParams = new URLSearchParams(splittedPath[1]);
        return `${urlEnd}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      }
    },
    embedUrl() {
      return `https://www.youtube.com/embed/${this.urlEnd}`;
    }
  },
  async mounted() {
    this.finishElementExecution({
      element: this.element,
      courseId: this.courseId
    });
  },
  methods: {
    ...mapActions(['finishElementExecution'])
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 16px;
}
</style>
